import { useCallback } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { NewsFormValues } from './newsForm.constants'

interface UseNewsFormHandlersProps {
  setFieldValue: (field: keyof NewsFormValues, value: any) => void
  setDateError: (error: boolean) => void
}

export const useNewsFormHandlers = ({ setFieldValue, setDateError }: UseNewsFormHandlersProps) => {
  const handleContentTypeChange = useCallback(
    (e: any) => {
      const newContentType = e.target.value as string
      setFieldValue('contentType', newContentType)
      if (newContentType === 'noticia') {
        setFieldValue('document', null)
      }
    },
    [setFieldValue]
  )

  const handleTitleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue('title', e.target.value)
    },
    [setFieldValue]
  )

  const handleTagChange = useCallback(
    (e: any) => {
      setFieldValue('tag', e.target.value as string)
    },
    [setFieldValue]
  )

  const handleSiteChange = useCallback(
    (e: any) => {
      setFieldValue('site', e.target.value as string)
    },
    [setFieldValue]
  )

  const handleDateChange = useCallback(
    (d: Dayjs | null) => {
      const validDate = d && dayjs.isDayjs(d) ? d : null
      setFieldValue('date', validDate)
      if (validDate) {
        setDateError(false)
      }
    },
    [setFieldValue, setDateError]
  )

  const handleDescriptionChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setFieldValue('description', e.target.value)
    },
    [setFieldValue]
  )

  const handleBodyChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setFieldValue('body', e.target.value)
    },
    [setFieldValue]
  )

  const handleFileSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const f = e.target.files?.[0] || null
      setFieldValue('image', f)
    },
    [setFieldValue]
  )

  const handleDocumentSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const f = e.target.files?.[0] || null
      setFieldValue('document', f)
    },
    [setFieldValue]
  )

  const handleRemoveImage = useCallback(() => {
    setFieldValue('image', null)
  }, [setFieldValue])

  const handleRemoveDocument = useCallback(() => {
    setFieldValue('document', null)
  }, [setFieldValue])

  return {
    handleContentTypeChange,
    handleTitleChange,
    handleTagChange,
    handleSiteChange,
    handleDateChange,
    handleDescriptionChange,
    handleBodyChange,
    handleFileSelect,
    handleDocumentSelect,
    handleRemoveImage,
    handleRemoveDocument,
  }
}
